import { PayloadMap } from '@store/modules/ui/inbox/types';

export function transformPayloadMap(obj: Record<string, string>): PayloadMap {
    return {
        buttonText: obj.buttonText || obj.buttontext,
        terms: obj.terms,
        webDeeplink: obj.webDeeplink || obj.webdeeplink,
    };
}
